import { createContext, useContext, useMemo } from 'react'
import { withRouter } from 'react-router'
import store from 'store'

const SessionDatas = createContext()

export const useSessionData = props => {
  let context = useContext(SessionDatas)
  if (context === undefined) {
    throw new Error(`useSessionData must be called within <SessionProvider/>`)
  }
  // create additional methods
  let session = {
    get: val => store.get('session')[val],
    isAuthenticated: () => !!(context && context.id && context.email && context.token),
    login: data => {
      store.set('session', data)
    },
    logout: () => store.remove('session')
  }
  return session
}

const SessionProvider = ({ children }) => {
  const value = store.get('session')

  let values = useMemo(() => ({
    ...value
  }), [value])

  return (
    <SessionDatas.Provider value={values}>
      { children }
    </SessionDatas.Provider>
  )
}

export default withRouter(SessionProvider)
